import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { productApi } from "../api/productApi";
import "./ProductCarousel.css";

export default function ProductCarousel() {
  const railRef = useRef(null);
  const nav = useNavigate();
  const timerRef = useRef(null);

  const { t, i18n } = useTranslation();
  const [products, setProducts] = useState([]);

  // ✅ 3 dil pick (name / short) => nameAz/nameEn/nameRu və shortAz/shortEn/shortRu
  const pick = (p, base) => {
    const lang = (i18n?.language || "az").toLowerCase();
    const suffix = lang.startsWith("en") ? "En" : lang.startsWith("ru") ? "Ru" : "Az";

    const keyCamel = `${base}${suffix}`; // nameAz, shortEn...
    const keyPascal = `${base[0].toUpperCase() + base.slice(1)}${suffix}`; // NameAz

    return (
      p?.[keyCamel] ??
      p?.[keyPascal] ??
      // fallback AZ
      p?.[`${base}Az`] ??
      p?.[`${base[0].toUpperCase() + base.slice(1)}Az`] ??
      ""
    );
  };

  const scrollByPx = (px) => {
    if (!railRef.current) return;
    railRef.current.scrollBy({ left: px, behavior: "smooth" });
  };

  const autoNext = () => {
    const el = railRef.current;
    if (!el) return;

    const card = el.querySelector(".pcCard");
    const step = card ? card.getBoundingClientRect().width + 16 : 320;

    const maxScroll = el.scrollWidth - el.clientWidth;

    if (el.scrollLeft >= maxScroll - 2) {
      el.scrollTo({ left: 0, behavior: "smooth" });
    } else {
      el.scrollBy({ left: step, behavior: "smooth" });
    }
  };

  // ✅ auto scroll timer
  useEffect(() => {
    timerRef.current = setInterval(autoNext, 3500);
    return () => clearInterval(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ✅ load products backend-dən (sortOrder YOX)
  useEffect(() => {
    const load = async () => {
      try {
        const res = await productApi.getAll();
        const list = res.data || [];
        setProducts(list);
      } catch (e) {
        console.error("products load error:", e);
        setProducts([]);
      }
    };
    load();
  }, []);

  const pause = () => clearInterval(timerRef.current);
  const resume = () => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(autoNext, 3500);
  };

  return (
    <section className="container pcWrap" onMouseEnter={pause} onMouseLeave={resume}>
      {/* HEAD */}
      <div className="pcHead">
        <h2 className="pcTitle">{t("products_title")}</h2>

        <div className="pcBtns">
          <button onClick={() => scrollByPx(-500)} className="pcBtn" aria-label="Prev">
            ‹
          </button>
          <button onClick={() => scrollByPx(500)} className="pcBtn" aria-label="Next">
            ›
          </button>
        </div>
      </div>

      {/* RAIL */}
      <div className="pcRail" ref={railRef}>
        {products.map((p) => (
          <article key={p.id} className="pcCard">
            <div className="pcImgWrap">
              {p.hasImage ? (
                <img
                  src={productApi.getImageUrl(p.id) + `?t=${Date.now()}`}
                  alt={pick(p, "name")}
                  className="pcImg"
                />
              ) : (
                <div className="pcImg" style={{ display: "grid", placeItems: "center" }}>
                  {t("no_image")}
                </div>
              )}

              {/* price */}
              {/* {p.price ? <span className="pcPrice">{p.price}</span> : null} */}
            </div>

            <div className="pcBody">
              <div className="pcName">{pick(p, "name")}</div>
              <div className="pcDesc">{pick(p, "short")}</div>

              <button className="pcDetail" onClick={() => nav(`/mehsullar/${p.id}`)}>
                {t("details_btn")}
              </button>
            </div>
          </article>
        ))}

        {products.length === 0 ? (
          <div style={{ padding: 12, opacity: 0.7 }}>{t("no_products")}</div>
        ) : null}
      </div>
    </section>
  );
}
